export default __webpack_public_path__ + "static/cover-de41aa256025c1b369212cef1dd95074.png";